var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"field-component"},[_c('div',{staticClass:"field-name"},[_vm._v(_vm._s(_vm.title))]),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sep-line"},[_c('div',{staticClass:"sep-bg-wrapper"},[_c('div',{staticClass:"sep-bg"})]),_c('div',{staticClass:"sep-label"})])
}]

export { render, staticRenderFns }